(function() {
    'use strict';

    angular.module('order.constants', [])
        .constant('orderStatusConst', {
            draft: {
                value: 'draft',
                title: 'Nowe'
            },
            negotiated: {
                value: 'negotiated',
                title: 'Negocjowane'
            },
            saved: {
                value: 'saved',
                title: 'Zapisane'
            },
            waiting_for_files: {
                value: 'waiting_for_files',
                title: 'Oczekuje na pliki'
            },
            waiting_for_preflight: {
                value: 'waiting_for_preflight',
                title: 'Oczekuje na podgląd'
            },
            waiting_for_payment: {
                value: 'waiting_for_payment',
                title: 'Oczekuje na płatność'
            },
            in_realization: {
                value: 'in_realization',
                title: 'W realizacji'
            },
            in_production: {
                value: 'in_production',
                title: 'W produkcji'
            },
            done: {
                value: 'done',
                title: 'Zrealizowane'
            },
            canceled: {
                value: 'canceled',
                title: 'Anulowane'
            },
            deleted: {
                value: 'deleted',
                title: 'Usunięte'
            },
        })
        .constant('orderPaymentConst', {
            paid: {
                value: 'paid',
                title: 'Opłacone'
            },
            not_paid: {
                value: 'not_paid',
                title: 'Nieopłacone'
            },
        })
        .constant('orderPaymentMethodConst', {
            after_receiving: {
                value: 'after_receiving',
                title: 'Za pobraniem'
            },
            electronic_payment: {
                value: 'electronic_payment',
                title: 'Płatności elektroniczne'
            },
            prepayment: {
                value: 'prepayment',
                title: 'Przedpłata na konto'
            },
            deadline: {
                value: 'deadline',
                title: 'Termin płatności'
            },
        })
        .constant('orderDeliveryPackageMessageConst', {
            setAsPickupedSuccess: 'Paczka została oznaczona jako odebrana',
            setAsPickupedError: 'Błąd podczas oznaczenia paczki',
        })
        .constant('orderDeliveryStatusConst', {
            not_send: {
                value: 'not_send',
                title: 'Niewysłana'
            },
            stopped: {
                value: 'stopped',
                title: 'Zatrzymana'
            },
            send: {
                value: 'send',
                title: 'Wysłana'
            },
            delivered: {
                value: 'delivered',
                title: 'Doręczona'
            },
            returned: {
                value: 'returned',
                title: 'Zwrócona'
            }
        })
        .constant('invoiceTypeConst', {
            proforma: 'proforma_invoice',
            advance: 'advance_invoice',
            final: 'final_invoice',
            vat: 'vat_invoice',
        })
        .constant('invoiceMessageConst', {
            lackDateFilterCSVError: 'Wybierz miesiąc aby pobrać zestawienie CSV',
            lackDateFilterJPKFAError: 'Wybierz miesiąc aby pobrać plik JPK_FA',
            sourceFilterError: 'Wybierz źródło aby wygenerować plik',
        })
        .constant('orderInvoice', {
            true: {
                value: 'True',
                title: 'Tak'
            },
            false: {
                value: 'False',
                title: 'Nie'
            },
        })
        .constant('orderCreateMessagesConst', {
            createSuccess: 'Zamówienie zostało pomyślnie dodane!',
            createError: 'Nie udało się dodać zamówienia.'
        })
        .constant('orderUpdateMessagesConst', {
            confirmPaidTitle: 'zmienić status zamówienia na «Opłacone»',
            duplicated: 'Zamówienie zostało zduplikowane',
            productUpdated: 'Pozycja zamówienia została zaktualizowana',
            paid: 'Zamówienie zostało opłacone',
            confirmCompletedTitle: 'zmienić status zamówieńia na «Zrealizowane»',
            completed: 'Zamówienie zostało zrealizowane',
            confirmCanceledTitle: 'zmienić status zamówieńia na «Anulowane»',
            confirmUnstopDeliveryTitle: 'odblokować wysyłke zamówienia',
            canceled: 'Zamówienie zostało anulowane',
            stopped: 'Wysyłka zamówienia została zablokowana',
            unstopped: 'Wysyłka zamówienia została odblokowana',
            add_tracking: 'Numer trackingowy został zapisany!',
            updateTrackingNumber: 'zapisać numer trackingowy',
            updateDeliveryAddress: 'Adres dostawy został pomyślnie zaktualizowany!',
            error: 'Wystąpił błąd!',
            externalOrderConfirmSuccess: 'Pomyślnie stworzono fakturę proforma.',
            externalOrderConfirmError: 'Nie udało się stworzyć faktury proforma.',
            confirmIssueVatInvoiceTitle: 'wystawić fakturę VAT dla tego zamówienia',
            issueVatInvoiceSuccess: 'Faktura VAT została wystawiona.'
        })
        .constant('orderSendMessagesConst', {
            orderPackageConfirm: 'Paczka została potwierdzona.',
            orderAddressGenaratedLabel: 'Etykiety adresowe oraz numery trackingowe zostały pomyślnie wygenerowane',
            orderProductUpdateWeightOk: 'Waga produktu została pomyślnie zapisana.',
            orderProductUpdateWeightError: 'Podczas zapisywania wagi wystapił błąd!',
            orderError: 'Podczas pobrania zamówieńia wystapił błąd!',
            generateLabelError: 'Podczas generowania etykiety adresowej wystapił błąd',
            confirmPackageError: 'Podczas potwierdzenia zapakowania wystapił błąd',
            error: 'Wystąpił błąd!',
            orderStatusError: 'Wysłane mogą być tylko zamówienia ze statusem "W produkcji"',
            orderShipmentCmdCreated: 'Pomyślnie przesłano dane do wygenerowania przesyłki',
            orderShipmentInpostCreated: 'Pomyślnie utworzono nową przesyłkę',
        })
        .constant('orderPermissionsConst', {
            view: {
                value: 'view_order',
                errorMsg: 'Użytkownik nie ma uprawnień do podglądu zamówień!'
            },
            add: {
                value: 'add_order',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania zamówień!'
            },
            update: {
                value: 'change_order',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji zamówień!'
            },
            delete: {
                value: 'delete_order',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania zamówień!'
            },
            send: {
                value: 'send_order',
                errorMsg: 'Użytkownik nie ma uprawnień do wysyłania zamówień!'
            },
            duplicate: {
                value: 'duplicate_order',
                errorMsg: 'Użytkownik nie ma uprawnień do duplikacji zamówień!'
            }
        })
        .constant('orderproductPermissionsConst', {
            view: {
                value: 'view_orderproduct',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu pozycji zamówień!'
            },
            add: {
                value: 'add_orderproduct',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania pozycji zamówień!'
            },
            update: {
                value: 'change_orderproduct',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji pozycji zamówień!'
            },
            delete: {
                value: 'delete_orderproduct',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania pozycji zamówień!'
            }
        })
        .constant('orderDeliveryAddressPermissionsConst', {
            view: {
                value: 'view_orderdeliveryaddress',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu adresu dostawy zamówieńia!'
            },
            add: {
                value: 'add_orderdeliveryaddress',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania adresu dostawy zamówieńia!'
            },
            update: {
                value: 'change_orderdeliveryaddress',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji adresu dostawy zamówieńia!'
            },
            delete: {
                value: 'delete_orderdeliveryaddress',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania adresu dostawy zamówieńia!'
            }
        })
        .constant('invoicePermissionsConst', {
            view: {
                value: 'view_invoice',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu faktur!'
            },
            add: {
                value: 'add_invoice',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania faktury!'
            },
            update: {
                value: 'change_invoice',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji faktury!'
            },
            delete: {
                value: 'delete_invoice',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania faktury!'
            }
        })
        .constant('optimaPermissionsConst', {
            view: {
                value: 'view_optima',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu eksportu do Optimy!'
            }
        })
        .constant('paymentImportPermissionsConst', {
            view: {
                value: 'import_payments',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu importu wpłat!'
            }
        })
        .constant('preflightPreviewStatusConst', {
            info: 'info',
            ok: 'ok',
            alerts: 'alerts',
            error: 'error'
        })
        .constant('previewLoadingConst', {
            pagesLoadingText: 'Ładowanie stron',
            texturesLoadingText: 'Ładowanie tekstur'
        })
        .constant('operationTypeOptions', [
            {value: 'payment', title: 'Wpłata'},
            {value: 'payout', title: 'Wypłata'}
        ])
        .constant('operationSourceOptions', [
            {value: 'dotpay', title: 'Dotpay'},
            {value: 'paypal', title: 'PayPal'}
        ])
        .constant('operationMessagesConst', {
            downloadError: 'Nie udało się wygenerować raportu.'
        })
        .constant('orderCurrencyOptionsConst', [
            {value: 'PLN', title: 'PLN'},
            {value: 'EUR', title: 'EUR'}
        ])
        .constant('orderPlShopLangOptionsConst', [
            {value: 'pl', title: 'PL'},
            {value: 'de', title: 'DE'},
            {value: 'en', title: 'EN'}
        ])
        .constant('orderDeShopLangOptionsConst', [
            {value: 'cpde', title: 'DE [DE]'},
            {value: 'cpen', title: 'EN [DE]'}
        ])
        .constant('orderNegotiationsMessagesConst', {
            negotiationsApproved: 'Pomyślnie przyjęto negocjacje.',
            negotiationsDeclined: 'Pomyślnie odrzucono negocjacje.'
        })
        .constant('orderSourceConst', {
            allegro: {
                value: 'ALLEGRO',
                title: 'Allegro'
            }
        }).constant('orderShipmentCmdStatusConst', {
            error: {
                value: 'ERROR',
                title: 'Błąd podczas generowania przesyłki'
            },
            in_progress: {
                value: 'IN_PROGRESS',
                title: 'W trakcie generowania przesyłki'
            },
            success: {
                value: 'SUCCESS',
                title: 'Pomyślnie utworzono przesyłkę'
            }
        }).constant('orderShelfMessagesConst', {
            add: 'Dodano półkę do zamówienia!',
            update: 'Zaktualizowano półkę zamówienia!',
            delete: 'Półka zamówienia została usunięta!',
            error: 'Wystąpił bład!'
        }).constant('orderShelfPermissionsConst', {
            view: {
                value: 'view_ordershelf',
                errorMsg: 'Użytkownik nie ma uprawnień do podglądu półki zamówienia!'
            },
            add: {
                value: 'add_ordershelf',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania półki zamówienia!'
            },
            update: {
                value: 'change_ordershelf',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji półki zamówienia!'
            },
            delete: {
                value: 'delete_ordershelf',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania półki zamówienia!'
            }
        }).constant('orderShelfNotificationMessagesConst', {
            add: 'Wysłano powiadomienie!',
            error: 'Wystąpił bład!'
        }).constant('orderShelfNotificationPermissionsConst', {
            view: {
                value: 'view_ordershelfnotification',
                errorMsg: 'Użytkownik nie ma uprawnień do podglądu powiadomień związanych z półką!'
            },
            add: {
                value: 'add_ordershelfnotification',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania powiadomień związanych z półką!'
            },
            update: {
                value: 'change_ordershelfnotification',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji powiadomień związanych z półką!'
            },
            delete: {
                value: 'delete_ordershelfnotification',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania powiadomień związanych z półką!'
            }
        });
})();
